/* tslint:disable */
/* eslint-disable */
/**
 * Pet Profile A Service
 * Pet Profile A Layer Service For more information or information on how this data maps to the kryios data see [here](https://chewyinc.atlassian.net/wiki/spaces/MPROD/pages/1957927091/Pet+Property+to+Data+Mapping)
 *
 * The version of the OpenAPI document: 1.0
 * Contact: DL-IT_Pet_Profile@chewy.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { PetTypeModel } from './PetTypeModel';
import {
    PetTypeModelFromJSON,
    PetTypeModelFromJSONTyped,
    PetTypeModelToJSON,
} from './PetTypeModel';

/**
 * 
 * @export
 * @interface PetPrimaryDisciplineModel
 */
export interface PetPrimaryDisciplineModel {
    /**
     * 
     * @type {number}
     * @memberof PetPrimaryDisciplineModel
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof PetPrimaryDisciplineModel
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof PetPrimaryDisciplineModel
     */
    groupName?: string;
    /**
     * Only modifiable during update.
     * @type {boolean}
     * @memberof PetPrimaryDisciplineModel
     */
    markForDelete?: boolean;
    /**
     * 
     * @type {PetTypeModel}
     * @memberof PetPrimaryDisciplineModel
     */
    type?: PetTypeModel;
}

/**
 * Check if a given object implements the PetPrimaryDisciplineModel interface.
 */
export function instanceOfPetPrimaryDisciplineModel(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function PetPrimaryDisciplineModelFromJSON(json: any): PetPrimaryDisciplineModel {
    return PetPrimaryDisciplineModelFromJSONTyped(json, false);
}

export function PetPrimaryDisciplineModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): PetPrimaryDisciplineModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'name': !exists(json, 'name') ? undefined : json['name'],
        'groupName': !exists(json, 'groupName') ? undefined : json['groupName'],
        'markForDelete': !exists(json, 'markForDelete') ? undefined : json['markForDelete'],
        'type': !exists(json, 'type') ? undefined : PetTypeModelFromJSON(json['type']),
    };
}

export function PetPrimaryDisciplineModelToJSON(value?: PetPrimaryDisciplineModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'name': value.name,
        'groupName': value.groupName,
        'markForDelete': value.markForDelete,
        'type': PetTypeModelToJSON(value.type),
    };
}

